import { Requirements } from 'app/routes';

const EmptyRequirements: Requirements = {
    methods: () => ({}),
    resolve: () => [],
    error: () => [],
};

export default EmptyRequirements;
